import React from 'react'
import { styled } from 'linaria/react'
import ProductSpecification from './ProductSpecification'
import { ProductAccordion } from './ProductAccordion'
import { InfoEmpty, WarningTriangle, Wrench, YouTube } from 'iconoir-react'
import { VideoPlayer } from '../../CustomElements/VBElements/VideoPlayer'
import ProductReviews from './ProductReviews'
import { useContext } from 'react'
import { SiteContext } from '../../Global/SiteContext'
import ClpArea from './ClpArea'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import { getStringByPropertyName, isArrayWithItems } from '../../Core/Util/Helpers'
import ProductAboutBrand from './ProductAboutBrand'
import ProductSpareParts from './ProductSpareParts'
import ProductQuestions from './ProductQuestions'

const ProductInfoContainer = styled.div`
   ${theme.below.md} {
      margin-bottom: 1rem;
   }

   .product-long-desc-container {
      white-space: pre-wrap;
   }

   .product-long-desc-container p {
      font-size: 1rem;
   }

   .product-page-title {
      font-family: var(--font-grotesk);
      font-weight: 700;
      font-size: 28px;
      ${theme.below.md} {
         margin-bottom: 0.5rem;
      }
   }

   .accordion-button {
      /* font-family: var(--font-grotesk); */
      font-size: ${theme.font.size.responsiveHeaderM};
      ${theme.above.lg} {
         font-size: 24px;
      }
   }
`

function shouldShowAboutBrandAccordion(brand) {
   if (!brand) {
      return false
   }

   const brandProps = brand?.data?.items?.find(
      comp => comp?.type == VB_CATEGORY_SETTINGS
   )?.properties

   const brandText = getStringByPropertyName(brandProps, 'description')
   const customContent = getStringByPropertyName(brandProps, 'customContent')
   const brandImage =
      brand?.images && brand.images.length > 0 ? brand.images[0] : undefined

   return brandImage || brandText || customContent
}

const ProductInfo = ({ productData, brand }) => {
   const t = useIntl()
   const { productReviews, productInformation } = useContext(SiteContext)
   const { videos, spareParts } = productInformation ?? {}

   const showPictogram = productData?.customFields
      ?.filter(spec => spec.key.startsWith('ghs'))
      .some(function (obj) {
         return obj?.boolValue === true
      })

   const showProductReviews =
      productReviews && productReviews?.reviews.length > 0

   const showAboutBrandAccordion = shouldShowAboutBrandAccordion(brand)

   return (
      <ProductInfoContainer>
         <ProductAccordion title={t('product description')} isOpen={true}>
            <div className="product-long-desc-container">
               <div
                  dangerouslySetInnerHTML={{ __html: productData?.description }}
               />
            </div>
         </ProductAccordion>

         {showPictogram && (
            <>
               <hr className="my-32"></hr>
               <ProductAccordion
                  title={'Säkerhetsinformation'}
                  isOpen={true}
                  icon={
                     <WarningTriangle
                        width="1.8rem"
                        height="1.8rem"
                        strokeWidth={2.5}
                     ></WarningTriangle>
                  }
               >
                  <ClpArea product={productData}></ClpArea>
               </ProductAccordion>
            </>
         )}

         <ProductSpecification
            productInformation={productInformation}
         ></ProductSpecification>

         {isArrayWithItems(videos) && (
            <>
               <hr className="my-32"></hr>
               <ProductAccordion
                  isOpen={true}
                  title={t('product film')}
                  icon={
                     <YouTube
                        width="1.8rem"
                        height="1.8rem"
                        color="#9f1f10"
                        strokeWidth={2.5}
                     ></YouTube>
                  }
               >
                  <div className="row gy-4">
                     {videos?.map((video, index) => {
                        return (
                           <div className="col-12 col-sm-6" key={video?.value}>
                              <VideoPlayer
                                 title={video?.Title}
                                 videoId={video?.Value}
                                 titleSize="1.35rem"
                              ></VideoPlayer>
                           </div>
                        )
                     })}
                  </div>
               </ProductAccordion>
            </>
         )}

         {showProductReviews && (
            <>
               <hr className="my-32"></hr>
               <ProductReviews></ProductReviews>
            </>
         )}
         
         {isArrayWithItems(spareParts) && (
            <>
               <hr className="my-32"></hr>
               <ProductAccordion
                  title={t('spareparts')}
                  icon={
                     <Wrench
                        width="1.8rem"
                        height="1.8rem"
                        strokeWidth={2.5}
                     ></Wrench>
                  }
               >
                  <ProductSpareParts spareParts={spareParts} />
               </ProductAccordion>
            </>
         )}

         {showAboutBrandAccordion && (
            <>
               <hr className="my-32"></hr>
               <ProductAccordion
                  title={t('about the brand')}
                  icon={
                     <InfoEmpty
                        width="1.8rem"
                        height="1.8rem"
                        strokeWidth={2.5}
                     ></InfoEmpty>
                  }
               >
                  <ProductAboutBrand brand={brand} brandSupplierInfo={productInformation?.brandSupplier}/>
               </ProductAccordion>
            </>
         )}

         <hr className="my-32"></hr>

         <ProductQuestions></ProductQuestions>
      </ProductInfoContainer>
   )
}

export default ProductInfo
